import { useCallback } from 'react';

import { stripHtmlTags } from '@change-corgi/core/html';

import { useNewsAndGuidesDetailsPageData } from 'src/app/pages/newsAndGuides/details/pageContext';
import type { ShareActionsOptions } from 'src/app/shared/hooks/share';

import type { Channel } from './types';

export function useGetShareContent(): ShareActionsOptions<Channel>['getContent'] {
	const {
		data: {
			details: { title, content },
		},
	} = useNewsAndGuidesDetailsPageData();

	return useCallback(
		(channel, type) => {
			switch (channel) {
				case 'twitter':
					return title;
				case 'email':
					if (type === 'title') return title;
					return stripHtmlTags(content);
				default:
					return '';
			}
		},
		[title, content],
	);
}
